// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const listWorkflowResultGroupsQuery: any = graphql(`
  query ListWorkflowResultGroups(
    $assigneeId: IDQueryOperatorArgs
    $contentId: IDQueryOperatorArgs
    $createdAt: DateQueryOperatorArgs
    $includeTotalCount: Boolean! = true
    $ordering: [OrderBy!]
    $page: Int! = 0
    $pageSize: Int! = 7
    $workflow: IDQueryOperatorArgs
  ) {
    workflowResultGroups(
      assigneeId: $assigneeId
      contentId: $contentId
      createdAt: $createdAt
      includeTotalCount: $includeTotalCount
      ordering: $ordering
      page: $page
      pageSize: $pageSize
      workflow: $workflow
    ) {
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        node {
          id
          createdAt
          triggeredForUsers
          totalAssignments
          completedAssignments
          audience {
            dateRange {
              after
              before
            }
            days
            id
            image
            matchingCriteria
            name
            segmentationType
            type
          }
          settings {
            assignmentOptions {
              delay
            }
            conditionals {
              days
              id
              name
              type
            }
            daysToComplete
            dueFromHired
            escalateBuddy
            escalateManager
            escalationContacts {
              fullName
              id
              image
            }
            name
            nonReminderMessages {
              ...NotificationMessageDetailsFragment
            }
            objectNumber
            objectType
            overdueMessages {
              cadence
              message {
                ...NotificationMessageDetailsFragment
              }
              totalMessages
            }
            partnerPermissions
            reminderMessages {
              message {
                ...NotificationMessageDetailsFragment
              }
              timeBeforeDue
            }
            requireRecompletion
            responses {
              content {
                contentType
                id
                title
                isRecompletable
              }
              type
            }
            shareOptions {
              emailBody
              emailFromEmail
              emailFromName
              emailSubject
            }
            triggerObject {
              id
              title
            }
            type
          }
          assigner {
            id
            name
          }
        }
      }
    }
  }
`);
